<template>
	<div class="phcontactus">
		<el-backtop ></el-backtop>
		<hpheader></hpheader>

		<position-bar :positionNav="positionNav">
		</position-bar>

		<div id="container"></div>
		
		<div class="information">
			<div class="information-hea">
				{{conuservices}}
			</div>
			<div class="information-title">
				{{conanticoniden}}
			</div>
<!--			<div class="information-title">-->
<!--			  {{conhaanticoniden}}-->
<!--			</div>-->
<!--			<div class="information-title">-->
<!--				{{condadownlo}}-->
<!--			</div>-->
<!--			<div class="information-title">-->
<!--				{{conmaintenance}}-->
<!--			</div>-->
<!--			<div class="information-title">-->
<!--				{{concomprob}}-->
<!--			</div>-->
			<div class="information-title">
				{{ contoptitle }}
			</div>
<!--			<div class="information-title">-->
<!--				{{ confoptitle }}-->
<!--			</div>-->
			<div class="information-title">
				{{cononlinepreview}}
			</div>
<!--			<div class="information-title">-->
<!--				{{contips}}-->
<!--			</div>-->
		</div>
		<div class="leavinginput">
			<el-form :model="formData" ref="formData" :rules="rules" label-width="0" class="demo-ruleForm">
				<div class="leavinput-item">
					<div class="leavinputitem-title">{{ conname }}</div>
					<el-form-item prop="name" class="form-item" >
						<el-input v-model="formData.name" :placeholder="pleaseent"></el-input>
					</el-form-item>
				</div>
				<div class="leavinput-item">
					<div class="leavinputitem-title">{{ concompany }}</div>
					<el-form-item prop="company" class="form-item" >
						<el-input v-model="formData.company" :placeholder="pleaseent"></el-input>
					</el-form-item>
				</div>
				<div class="leavinput-item">
					<div class="leavinputitem-title">{{ conphone }}</div>
					<el-form-item prop="phone" class="form-item" >
						<el-input v-model="formData.phone" :placeholder="pleaseent"></el-input>
					</el-form-item>
				</div>
				<div class="leavinput-item">
					<div class="leavinputitem-title">{{ conemail }}</div>
					<el-form-item prop="email" class="form-item" >
						<el-input v-model="formData.email" :placeholder="pleaseent"></el-input>
					</el-form-item>
				</div>
				<div class="leavinput-item">
					<div class="leavinputitem-title">{{concountry}}</div>
					<el-form-item prop="country" class="form-item" >
						<el-input v-model="formData.country" :placeholder="pleaseent"></el-input>
					</el-form-item>
				</div>
				<div class="leavinput-item">
					<div class="leavinputitem-title">{{concontent}}</div>
					<el-form-item prop="content" class="form-item">
						<el-input
								type="textarea"
								:placeholder="pleaseent"
								:rows="4"
								v-model="formData.content">
						</el-input>
					</el-form-item>
				</div>
				<div class="leavinput-butcont">
					<div class="leavinput-but" :class="$store.state.brand" @click="submitForm('formData')">
						{{conquerysub}}
					</div>
				</div>
			</el-form>
		</div>
		<div id="feedback" style="padding: .2rem"></div>
		<div class="feedback" >
			<div class="feedback-hea">{{conproblfeedba}}</div>
			<div class="feedback-cont">
				<div class="feedback-item"  v-for="(item,index) in eavingmsg">
					<div class="feedback-itemhea">
						{{concontent}}：{{item.company}}
					</div>
					<div class="feedback-itemfoo">
						{{concustomserfeed}}：{{item.content}}
					</div>
				</div>
			</div>
		</div>
		<div class="pafention" :class="$store.state.brand">
			<el-pagination
			  background
			  :page-size="5"
			  :pager-count="4"
			  @current-change="currentPage"
			  layout="prev, pager, next"
			  :total="eavingtotal">
			</el-pagination>
		</div>

		<div class="join-banner">
			<img :src="jobSetting.banner" alt="">
			<span @click="joinUs">Join Us</span>
		</div>

		<hpfooter ref="footer"></hpfooter>
	</div>
</template>

<script>
	import hpheader from '../../common/hpheader.vue'
	import hpfooter from '../../common/hpfooter.vue'
	import {session} from "../../storage/storage";
	import positionBar from '../../components/ph-position-bar.vue'

	export default{
		data(){
			var checkEmail = (rule, value, callback) => {
				const regEmail = /^([a-zA-Z0-9])+@([a-zA-Z0-9_-])+([a-zA-Z0-9_-])+/;
				const len = 50
				if(value.length > len){
					return callback(new Error("E-mail cannot be longer than "+len+" characters"));
				}
				if (regEmail.test(value)) {
					console.log(regEmail.test(value));
					return callback();
				} else {
					callback(new Error("Please enter the correct E-mail"));
				}
			};
			return{
				form: {},
				name:'',
				eavingtotal:0,
				zmucnt:'桂林啄木鸟医疗器械',
				conuservices:"联系我们",
				conanticoniden:'公司地址:桂林国家高新技术企业',
				conhaanticoniden:'空间信息工业园',
				condadownlo:'人力资源邮箱:',
				conmaintenance:'zmnhr02@glwoodpecker.com',
				concomprob:'客户服务电话: 0773-2350521/13978361362',
				contoptitle:'销售部门电话: 0773--5831172/5835305',
				confoptitle:'传真:0773-5822450',
				cononlinepreview:'E-mail: woodpecker4@glwoodpecker.com',
				contips:"邮政编码: 541004",
				conquerysub:'提交',
				conname:'姓名',
				concompany:'公司',
				conphone:'电话',
				conemail:'邮箱',
				concountry:'国家',
				concontent:'留言内容',
				conproblfeedba:'问题反馈',
				pleaseent:'请输入',
				concustomserfeed:'客服反馈',
				company:'',
				phone:'',
				email:'',
				country:'',
				content:'',
				id:'',
				navheader:true,
				heshow:false,
				show: false,
				playli:true,
				playri:true,
				acindex:1,
				page:1,
				eavingmsg:'',
				value: '',
				valuelang: '',
				tableData: [],
				formData:{},
				rules:{
					name: [
						{ required: true, message: 'Please enter name', trigger: 'blur' },
						{ max: 50,  trigger: 'blur' }
					],
					company: [
						{ required: true, message: 'Please enter company', trigger: 'blur' },
						{ max: 50,  trigger: 'blur' }
					],
					phone: [
						{ required: true, message: 'Please enter telephone number',trigger: 'blur' },
						{ max: 50, trigger: 'blur' }
					],
					email: [
						{ required: true, message: 'Please enter e-mail',trigger: 'blur' },
						{ validator: checkEmail, trigger: 'blur' }
					],
					country: [
						{ required: true, message: 'Please enter country',trigger: 'blur' },
						{ max: 50,  trigger: 'blur' }
					],
					content: [
						{ required: true, message: 'Please enter content',trigger: 'blur' },
						{ max: 250,  trigger: 'blur' }
					],
				},
				positionNav:[
					{
						title:'Home',
						path:'/pchome',
					},
					{
						title:'Contact Us',
						path:'',
					},
				],
				jobSetting:{
					banner:''
				}
			}
		},
		created() {
			this.ress()
			this.pageParam() //页面静态参数
			this.pcgetleavingmsg()
			// this.init()
			this.restForm()
		},
		components:{
			hpfooter,
			hpheader,
			positionBar
		},
		watch:{
			'$route': 'getParams'
		},
		mounted() {

			this.init()
			if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {

			}else{
				this.$router.push({path:'./pccontactus',query:{e:this.$route.query.e}})
				return
			}
			this.getParams()
			// this.ress()

		},
		methods:{
			joinUs(){
				this.$router.push({path:'/phelites'})
			},
			restForm(){
				this.formData = {
					name:'',
					company:'',
					phone:'',
					email:'',
					country:'',
					content:'',
				}
			},
			currentPage(e){
				this.page=e
				this.pcgetleavingmsg()
			    /* this.page=val;
			    this.changePage(); */
			},
			init () {
				/* {lng:110.343116,lat:25.274862} */
			 var map = new AMap.Map('container', {
			         resizeEnable: true,
			         center: [110.336512,25.269241],
			         zoom: 10,
					 lang:session.get("lang") == '' ? 'cn' : session.get("lang")
			     });
			 
			     var marker = new AMap.Marker({
			         position: map.getCenter(),
			        //  icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
			         anchor:'bottom-center',
			         offset: new AMap.Pixel(0, 0)
			     });
			 
			     marker.setMap(map);
			 
			     // 设置鼠标划过点标记显示的文字提示
			     marker.setTitle('我是marker的title');
			 
			     // 设置label标签
			     // label默认蓝框白底左上角显示，样式className为：amap-marker-label
			     marker.setLabel({
			        direction:'right',
			        offset: new AMap.Pixel(10, 0),  //设置文本标注偏移量
					content: this.zmucnt, //设置文本标注内容桂林啄木鸟医疗器械
			     });
			     this.jobBanner()
			},
			jobBanner(){
				this.$api.get_job_contact_banner({device:'mobile'}).then(res => {
					this.jobSetting.banner = res.data.value
				})
			},
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let data={
							channel_ids: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
							name:this.formData.name,
							company:this.formData.company,
							phone:this.formData.phone,
							email:this.formData.email,
							country:this.formData.country,
							content:this.formData.content,
							lang: this.lang
						}
						this.$api.leaving_msg(data).then((res) => {
							if (res.code == 1) {
								this.$message({
									message: res.msg,
									type: "success",
								});
								this.restForm()
							} else {
								this.$message.error(res.msg);
							}
						});
					} else {
						return false;
					}
				});
			},
			onSubmit() {
				let data={
				channel_ids: session.get("channel_id") == null ? 1 : session.get("channel_id"),
				name:this.name,
				company:this.company,
				phone:this.phone,
				email:this.email,
				country:this.country,
				content:this.content,
				}
				this.$api.leaving_msg(data).then((res) => {
				if (res.code == 1) {
					this.$message({
					message: res.msg,
					type: "success",
					});
					this.form = {};
				} else {
					this.$message.error(res.msg);
				}
				});
			},
			pageParam(){
				let lang =  session.get("lang");
				if (lang === "cn"){
					this.conuservices = "联系我们"
					this.zmucnt='桂林啄木鸟医疗器械'
					this.conanticoniden='公司地址:桂林国家高新技术企业',
					this.conhaanticoniden='空间信息工业园',
					this.condadownlo='人力资源邮箱:',
					this.conmaintenance='zmnhr02@glwoodpecker.com',
					this.concomprob='客户服务电话: 0773-2350521/13978361362',
					this.contoptitle='销售部门电话: 0773--5831172/5835305'
					this.confoptitle='传真:0773-5822450'
					this.cononlinepreview='E-mail: woodpecker4@glwoodecker.com'
					this.contips="邮政编码: 541004"
					this.conquerysub="提交"
					this.conname='姓名'
					this.concompany='公司'
					this.conphone='电话'
					this.conemail='邮箱'
					this.concountry='国家'
					this.concontent='留言内容'
					this.conproblfeedba='问题反馈'
					this.pleaseent='请输入'
					this.concustomserfeed='客服反馈'
		
				}else{
					this.conuservices = "CONTACT US"
					this.zmucnt='Guilin woodpecker medical equipment'
					this.conanticoniden='Address: Information Industrial Park,Guilin National High-Tech Zone,Guilin,Guangxi,541004 P.R.China',
					this.conhaanticoniden='Company address: Guilin National High Tech Enterprise',
					this.condadownlo='HR email:',
					this.conmaintenance='zmnhr02@glwoodpecker.com',
					this.concomprob='Customer service Tel.: 0773-2350521 / 13978361362',
					this.contoptitle='Sales Dept：+86-773-5873196'
					this.confoptitle='Fax: 0773-5822450'
					this.cononlinepreview='E-mail: woodpecker4@glwoodpecker.com'
					this.contips="Postal Code: 541004"
					this.conquerysub="submit"
					this.conname='Name'
					this.concompany='Company'
					this.conphone='Telephone'
					this.conemail='E-mail'
					this.concountry='Country'
					this.concontent='Content'
					this.conproblfeedba='PROBLEM FEEDBACK'
					this.pleaseent='Please enter'
					this.concustomserfeed='Customer service feedback'
				}
			},
			pcgetleavingmsg(){
				let data={
					lang:session.get("lang") == '' ? 'cn' : session.get("lang"),
					channel_id: session.get("channel_id") == '' ? 1 : session.get("channel_id"),
					page:this.page,
					pageSize:5,
				}
				this.$api.get_leaving_msg(data).then((res) => {
					this.eavingmsg=res.data.data
					this.eavingtotal=res.data.total
				});
			},
			ress(){
				var html = document.documentElement; //获取根元素
				var designWidth = 750; //设计稿宽度
				//html.clientWidth 视口宽度
				html.style.fontSize = html.clientWidth / designWidth * 100 + "px"; //设置字体大小
			},
			getParams(){
				var selectId = this.$route.query.select == 2 ? 'feedback' : 'container'
				this.$refs.footer.scrollIntoView(selectId)
			}
		}
	}
</script>

<style>
	body{
		margin: 0;
		padding: 0;
	}
	.phcontactus{
		background: #FAFAFA;
		padding-top: 0.88rem;
	}
	.phhonor{
		background: #FAFAFA;
		padding-top: 0.88rem;
	}
	.phhonor-hea{
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 7.5rem;
		height: 0.88rem;
		background: #FFFFFF;
	}
	.phhonorhea-left{
		margin-left: 0.3rem;
		width: 0.97rem;
		height: 0.5rem;
	}
	.phhonorhea-left img{
		width: 100%;
		height: 100%;
	}
	.phhonorhea-right{
		margin-right: 0.3rem;
		width: 0.38rem;
		height: 0.38rem;
	}
	.phhonorhea-right img{
		width: 100%;
		height: 100%;
	}
	.map{
		width: 7.5rem;
		height: 4rem;
	}
	.BMap_cpyCtrl{
		display: none !important;
	}
	.anchorBL{
		display: none !important;
	}
	.information{
		padding-left: 0.3rem;
		padding-top: 0.4rem;
	}
	.information-hea{
		font-size: 0.4rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.02rem;
		margin-bottom: 0.4rem;
	}
	.information-title{
		font-size: 0.24rem;
		font-weight: 400;
		color: #5d5f5f;
		margin-bottom: 0.2rem;
	}
	.leavinginput{
		padding-left: 0.3rem;
		padding-top: 0.4rem;
		background: #FAFAFA;
	}
	.leavinput-item{
		
	}
	.leavinputitem-title{
		font-size: 0.24rem;
		font-weight: 400;
		color: #5d5f5f;
		margin-bottom: 0.16rem;
	}
	
	.leavinput-item input{
		border: none;
		width: 6.89rem;
		height: 0.6rem;
		outline: none;
		border-bottom: 0.01rem solid #CCCCCC;
		/*margin-bottom: 0.4rem;*/
		line-height: normal;
	}
	.form-item textarea{
		width: 6.89rem;
		height: 1.86rem;
		background: #FFFFFF;
		border: none;
		border-bottom: 0.01rem solid #ccc;
		/*margin-bottom: 0.4rem;*/
	}
	.form-item textarea:focus-visible {
		outline: none;
	}
	.leavinput-butcont{
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.leavinput-but{
		width: 2.3rem;
		height: 0.6rem;
		/*background: #E31E24;*/
		border-radius: 0.3rem;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 0.24rem;
		font-weight: 400;
		color: #FFFFFF;
		letter-spacing: 0.01rem;
		margin-bottom: 0.4rem;
	}
	.feedback{
		padding-top: 0.4rem;
		padding-left: 0.3rem;
	}
	.feedback-hea{
		font-size: 0.36rem;
		font-weight: 600;
		color: #5d5f5f;
		letter-spacing: 0.01rem;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.feedback-cont{
		
	}
	.feedback-item{
		width: 6.9rem;
		border-bottom: 0.01rem solid #ccc;
	}
	.feedback-itemhea{
		font-size: 0.24rem;
		font-weight: 600;
		color: #5d5f5f;
		margin-top: 0.24rem;
		margin-bottom: 0.12rem;
	}
	.feedback-itemfoo{
		font-size: 0.2rem;
		font-weight: 400;
		color: #666666;
		margin-bottom: 0.24rem;
	}
	#container {
	    width: 7.5rem;
	    height: 4rem;
	}
	.amap-copyright{
		display: none !important;
	}
	.amap-logo{
		display: none !important;
	}
	.pafention{
		display: flex;
		justify-content: center;
		align-items: center;
		width: 80%;
		margin: 0 auto;
	}
	.el-pagination{
		
		margin-top: 0.5rem;
	}
	.leavinput-but.woodpecker , .pafention.woodpecker .el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #e62129;
		
	}
	.leavinput-but.dte , .pafention.dte .el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #1a4698;

	}
	.leavinput-but.dba , .pafention.dba .el-pagination.is-background .el-pager li:not(.disabled).active{
		background-color: #5d5f5f;

	}
	.el-pager{
	}
	.number {
		border-radius: 0.05rem;
	}
	.el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
		border-radius: 0.09rem;
		width: 0.48rem;
		height: 0.48rem;
		line-height: 0.48rem;
		font-size: 0.21rem;
		
		font-family: HelveticaNeue;
		color: #666;
	}
	.el-icon-arrow-right:before{
		
	}
	.el-pagination .btn-next .el-icon, .el-pagination .btn-prev .el-icon{
		font-size: 0.24rem;
	}

	.form-item {
		/*padding-left: 40px;*/
		/*margin-top: 10px;*/
	}
	.form-item input , .form-item .el-textarea__inner{
		padding: 0!important;
		border-radius: 0;
		background-color: #FAFAFA;
	}
	.form-item .el-form-item__error {
		font-weight: 400;
	}
	.form-item input::-webkit-input-placeholder, .form-item textarea::-webkit-input-placeholder {
		/* WebKit browsers */
		/* placeholder颜色  */
		color: #999!important;
		/* placeholder字号  */
		font-size: 40px;


	}
	.form-item input::-webkit-input-placeholder, .form-item textarea:-moz-placeholder {
		/* Mozilla Firefox 4 to 18 */
		color: #999!important;
		font-size: 40px;
	}
	.form-item input::-webkit-input-placeholder, .form-item textarea::-moz-placeholder {
		/* Mozilla Firefox 19+ */
		color: #999!important;
		font-size: 40px;
	}
	.form-item input::-webkit-input-placeholder, .form-item textarea::-ms-input-placeholder {
		/* Internet Explorer 10+ */
		color: #999!important;
		font-size: 40px;
	}
	.phcontactus .join-banner {
		position: relative;
		margin-bottom: 200px;
	}
	.phcontactus .join-banner img {
		width: 100%;
	}
	.phcontactus .join-banner span {
		position: absolute;
		left: 50%;
		transform: translate(-50%,0);
		bottom: 200px;
		color: #ffffff;
		font-size: 36px;
		display: block;
		padding: 30px 50px;
		background-color: rgba(0,0,0, .5);
		border-radius: 100px;
	}
</style>
